import { createIcon } from './icon-utils';

export const ExpandIcon = createIcon({
  path: 'M9.328 4.635a.75.75 0 1 1 1.036 1.085L6.846 9.08a1.002 1.002 0 0 1-1.384 0L1.944 5.72a.75.75 0 0 1 1.035-1.085l3.175 3.031 3.174-3.03z',
  style: { height: 12, width: 12 },
  viewBox: '0 0 12 12',
});
